import { Dialog } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/solid'
import React, { SetStateAction, useEffect, useState } from 'react'

const ErrorModal: React.FC<{
  errorMessage: string
  setErrMsg: (value: SetStateAction<string | null>) => void
}> = ({ errorMessage, setErrMsg }) => {
  const [isOpen, setIsOpen] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(false)
      setTimeout(() => {
        setErrMsg(null)
      }, 500)
    }, 4500)
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <Dialog
      as='div'
      className='fixed inset-0 z-50 h-full w-full overflow-y-auto'
      open={isOpen}
      onClose={handleClose}
    >
      <div className='min-h-screen px-4 text-center'>
        {/* The backdrop, rendered as a fixed sibling to the panel container */}
        <div className='fixed inset-0 bg-black/30' aria-hidden='true' />

        <div className='fixed bottom-5 left-0 w-full'>
          <div className='inline-block transform overflow-hidden rounded-lg bg-white text-left align-middle shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:align-middle'>
            <div className='relative p-6'>
              <div className='absolute right-3 top-3 flex items-center justify-end'>
                <button
                  className='text-gray-400 hover:text-gray-500'
                  onClick={handleClose}
                >
                  <XMarkIcon className='h-5 w-5' />
                </button>
              </div>
              <div className='mb-2 mt-4'>
                <p className='text-sm text-gray-500'>{errorMessage}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default ErrorModal
